import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { shortTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 bg-cream-beige border-y border-gold-light" data-id="element-212" data-mp="3sq1vbv6hrw06">
      <div className="max-w-7xl mx-auto px-4" data-id="element-213" data-mp="3ssej4oyxl0l5">
        <div className="text-center mb-7" data-id="element-214" data-mp="3nzbn8a6olf1s">
          <p className="text-navy font-bold tracking-widest uppercase text-sm" data-id="element-215" data-mp="3nxigkuw2iuts">
            ⭐ What Taekwondo Instructors Are Saying
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-216" data-mp="lhi7mdswu0m">
          {shortTestimonials.map((testimonial, index) => <motion.article key={testimonial.text} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-cream-card border border-gold-light p-6 rounded-2xl shadow-sm flex flex-col" data-id="element-217" data-mp="figzy32da38t" data-mpi={index}>
              <div className="flex gap-1 text-gold mb-4" aria-label="5 out of 5 stars" data-id="element-218" data-mp="cek3t884ixif">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" data-id="element-219" data-mp="ldnmib3dpawe" data-mpi={starIndex} />)}
              </div>
              <p className="text-ink italic mb-6 text-sm leading-relaxed" data-id="element-220" data-mp="q4nlrmzz0522">“{testimonial.text}”</p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-221" data-mp="v3qeq92oekto">
                <div className="w-10 h-10 rounded-full bg-navy flex items-center justify-center text-gold font-bold" data-id="element-222" data-mp="v5jlrph7b727">
                  {testimonial.initials}
                </div>
                <div data-id="element-223" data-mp="144oiqrd46sc9">
                  <div className="font-bold text-navy text-sm" data-id="element-224" data-mp="1422aepieg8sz">{testimonial.name}</div>
                  <div className="text-xs text-ink-soft" data-id="element-225" data-mp="190vq8ol5sbwb">{testimonial.role}</div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}